var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SchemaModuleUniversal } from './module-universal';
import * as rawJSONSchemaModuleTransplantSurgery from '../../schemas/module-transplant-surgery.json';
var SchemaModuleTransplantSurgery = (function (_super) {
    __extends(SchemaModuleTransplantSurgery, _super);
    function SchemaModuleTransplantSurgery() {
        var _this = _super.call(this) || this;
        _this.loadSchema(rawJSONSchemaModuleTransplantSurgery);
        return _this;
    }
    return SchemaModuleTransplantSurgery;
}(SchemaModuleUniversal));
export { SchemaModuleTransplantSurgery };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-transplant-surgery.ts.pre-build-optimizer.js